import { getProductFilteringAsQueryString } from '../Actions/ProductFiltering.action';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_LISTING_SET_PRODUCTS,
} from '../constants';

export const historyMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (typeof action === 'function') {
      // then call the function and pass `dispatch` and `getState` as arguments
      return action(dispatch, getState);
    }
    const { type, payload } = action;
    switch (type) {
      case PRODUCT_FILTERING_RECEIVE:
        if (!action.isInitialLoad) {
          const queryString = getProductFilteringAsQueryString(
            payload,
            action.keepAllUrlParams
          );
          const url =
            window.location.href.replace(window.location.search, '') +
            `${queryString ? '?' : ''}${queryString}`;
          window.history.pushState('search', 'Search Page', url);
        }
        break;
    }
    return next(action);
  };
